var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconZw = function SvgIconZw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.852 6.873a12 12 0 0 0-2.447-3.436l-8.404-.828-8.405.828-.08.08 3.357 3.356L12 7.029zM3.516 20.485q.066.067.133.132l8.351.775 8.351-.775a12 12 0 0 0 2.476-3.436l-15.523-.484z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.88 10.308 9.914 9.913 12 12l-2.087 2.087 13.96-.343a12 12 0 0 0 .008-3.436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 0a11.96 11.96 0 0 0-8.404 3.437h16.81A11.96 11.96 0 0 0 12 0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.307 10.309H23.88a12 12 0 0 0-1.03-3.436H6.872zM6.82 17.182h16.007c.511-1.068.87-2.223 1.046-3.436H10.255z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 24a11.96 11.96 0 0 0 8.35-3.383H3.649A11.96 11.96 0 0 0 12 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.285 2.81q-.4.336-.77.705L12 12l-8.485 8.486q.37.368.77.705l9.19-9.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m4.825 8.87.777 2.39h2.514L6.082 12.74l.777 2.391-2.034-1.478L2.79 15.13l.777-2.391-2.034-1.479h2.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m6.962 12.195-2.025-.718s-.15-1.404-.159-1.451a.783.783 0 1 0-1.523.354l-.567.571h1.009c0 1.048-.782 1.048-.782 2.091l.434 1.044h2.609l.434-1.044q.065-.15.081-.306c.375-.152.489-.542.489-.542"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconZw;